import { AdminLogFile } from "./AdminLogFile"

export class AdminLogs {
  capturedAtUtc: string

  logsRoot: string

  files: AdminLogFile[]

  constructor(data: Partial<AdminLogs> = {}) {
    this.capturedAtUtc = data.capturedAtUtc ?? ""

    this.logsRoot = data.logsRoot ?? ""

    this.files = (data.files ?? []).map((item) => new AdminLogFile(item))
  }
}
